<template>
  <div class="imgStyleContext">
    <img :src="getImgUrl(icon)" class="imgStyle" />
  </div>
</template>
<script>
export default {
  props: {
    icon: {
      type: String,
      default: "",
    },
  },
  methods: {
    getImgUrl(icon) {
      return require("../../../../../public/static/image/" + icon);
    },
  },
};
</script>
<style scoped>
.imgStyleContext {
  text-align: right;
  min-width: 300px;
  padding: 20px 5px 20px 10px;
}
.imgStyle {
  max-width: 300px;
}
</style>
